/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_LabelInputs */



/**
* | output |
* | --- |
* | "Timecode Format" |
*
* @param {Transcript_Export_Timecode_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_label = /** @type {((inputs?: Transcript_Export_Timecode_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format de timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode-Format")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato del timecode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Формат временного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato de código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード形式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato do código de tempo")
	return /** @type {LocalizedString} */ ("Timecode Format")
});